<template>
  <v-row align="stretch" justify="start">
    <v-col cols="12">
      <base-material-card
        color="coolrunner"
        icon="mdi-account-arrow-right"
        inline
        class="px-5 py-3"
        lg="4"
      >
        <template v-slot:after-heading>
          <div class="text-h2 font-weight-light">
            {{ $t("options") }}
          </div>
        </template>
        <v-row>
          <v-col cols="12">
            <v-expansion-panels
              :accordion="true"
              :focusable="true"
              :hover="true"
            >
              <v-expansion-panel
                v-for="(group, key, i) in groupedOptions"
                :key="i"
              >
                <v-expansion-panel-header>{{ key }}</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-col
                    v-for="(option, index) in group"
                    :key="index"
                    class="row"
                  >
                    <v-tooltip :key="option.key" bottom left>
                      <template v-slot:activator="{ on, attrs }">
                        <v-checkbox
                          v-if="option.type === 'boolean'"
                          v-model="option.value"
                          class="mr-auto"
                          true-value="1"
                          false-value="0"
                          :label="option.title || option.key"
                        />
                        <v-autocomplete
                          v-else-if="
                            ['select', 'multi_select'].includes(option.type)
                          "
                          :value="
                            option.type == 'multi_select'
                              ? $_.isString(option.value)
                                ? JSON.parse(option.value)
                                : option.value
                              : option.value
                          "
                          :items="option.values"
                          item-text="label"
                          item-value="value"
                          :multiple="option.type === 'multi_select'"
                          class="mr-auto"
                          :label="option.title || option.key"
                          @change="
                            val =>
                              (option.value = $_.isString(val)
                                ? val
                                : JSON.stringify(val))
                          "
                        />
                        <v-text-field
                          v-else
                          v-model="option.value"
                          :label="option.title || option.key"
                          v-on="on"
                        />
                      </template>
                      <span>{{ option.key }}</span>
                    </v-tooltip>

                    <v-btn
                      class="ml-5"
                      color="red"
                      @click="selectedOption = option.key"
                    >
                      <v-icon color="white">
                        mdi-delete
                      </v-icon>
                    </v-btn>
                  </v-col>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>
        <v-dialog :value="selectedOption !== null" max-width="340" persistent>
          <v-card>
            <v-card-title class="text-h5">
              {{ $t("confirm_action") }}
            </v-card-title>
            <v-card-text>
              {{ $t("confirm_delete", { type: $t("option").toLowerCase() }) }}
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn color="green darken-1" text @click="selectedOption = null">
                {{ $t("cancel") }}
              </v-btn>
              <v-btn color="green darken-1" text @click.stop="removeOption()">
                {{ $t("confirm") }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog :value="showNewModal" max-width="340" persistent>
          <v-card>
            <v-card-title class="text-h5">
              {{ $t("create_new", { type: $t("option").toLowerCase() }) }}
            </v-card-title>
            <v-col>
              <v-text-field v-model="newOption.key" :label="$t('key')" />
              <v-text-field v-model="newOption.value" :label="$t('value')" />
            </v-col>

            <v-card-actions>
              <v-spacer />
              <v-btn color="green darken-1" text @click="closeNewOption()">
                {{ $t("cancel") }}
              </v-btn>
              <v-btn color="green darken-1" text @click.stop="saveNewOption()">
                {{ $t("confirm") }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-row>
          <v-btn
            color="orange"
            class="ml-auto mt-5"
            @click="showNewModal = true"
          >
            <v-icon class="mr-3">
              mdi-plus
            </v-icon>
            {{ $t("new") }}
          </v-btn>
          <v-btn class="ml-2 mt-5" right color="green" @click="saveOptions">
            <v-icon class="mr-3">
              mdi-content-save
            </v-icon>
            {{ $t("save") }}
          </v-btn>
        </v-row>
      </base-material-card>
    </v-col>
  </v-row>
</template>
<script>
import _ from "lodash";

export default {
  props: {
    loading: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      availableOptions: [],
      customerOptions: [],
      selectedOption: null,
      showNewModal: false,
      newOption: {
        key: "",
        value: "",
        group: this.$t("uncategorized")
      }
    };
  },
  computed: {
    groupedOptions() {
      return _.groupBy(this.customerOptions, "group");
    }
  },
  created: function() {
    this.fetchOptions();
  },
  methods: {
    getOptionValue: function(value) {
      return JSON.parse(`'${value}'`);
    },
    fetchOptions: function() {
      Promise.all([
        this.$get(`/customers/${this.$route.params.id}/options`),
        this.$get("/customer/options")
      ]).then(values => {
        this.customerOptions = [...values[0].data];
        this.availableOptions = values[1].data.data;
        this.mutateOptions();
      });
    },
    mutateOptions: function() {
      _.each(this.availableOptions, opt => {
        var option = _.findIndex(this.customerOptions, option => {
          return option.key === opt.key;
        });

        if (option === -1) {
          this.customerOptions.push(opt);
        }
      });
      _.each(this.customerOptions, (opt, i) => {
        var option = _.find(this.availableOptions, option => {
          return option.key === opt.key;
        });

        if (option) {
          opt.title = option.title;
          opt.type = option.type;
          if (["select", "multi_select"].includes(option.type)) {
            opt.values = this.mutateSelectOptions(option.values);
          } else opt.values = option.values;
          opt.group = option.group;
        } else {
          opt.title = opt.key;
          opt.group = this.$t("uncategorized");
        }
      });

      this.customerOptions.sort((a, b) => {
        if (a.group === this.$t("uncategorized")) return 1;
        else if (b.group === this.$t("uncategorized")) return -1;

        return a.group.localeCompare(b.group);
      });
    },
    removeOption: function() {
      const index = this.$_.findIndex(this.customerOptions, [
        "key",
        this.selectedOption
      ]);
      this.customerOptions[index].value = null;
      this.selectedOption = null;
    },
    closeNewOption: function() {
      this.showNewModal = false;
      this.resetNewOption();
    },
    saveNewOption: function() {
      this.customerOptions.push(this.newOption);
      this.closeNewOption();
    },
    resetNewOption: function() {
      this.newOption = {
        key: "",
        value: "",
        group: this.$t("uncategorized")
      };
    },
    saveOptions: function() {
      const opts = this.$_.filter(
        this.customerOptions,
        val => val.value != null
      );

      this.$post(`/customers/${`${this.$route.params.id}`}/options`, {
        options: opts
      })
        .then(response => {
          this.$toast(`${this.$t("options")} ${this.$t("saved_correctly")}`);

          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    mutateSelectOptions: function(values) {
      return this.$_.map(values, (value, key) => {
        const label = this.$_.isString(value)
          ? value
          : value.title[this.$i18n.locale];
        return { label, value: key };
      });
    }
  }
};
</script>
